import styled from '@emotion/styled';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const Container = styled.div<{ isGuest: boolean }>`
  ${MEDIA_QUERY.DESKTOP_MASSIVE} {
    ${({ isGuest }) => (isGuest ? `border-left: 1px solid ${COLORS3.BLACK_030}` : null)};
    ${({ isGuest }) => (isGuest ? `border-right: 1px solid ${COLORS3.BLACK_030}` : null)};
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 700px;
  margin: auto;
  padding: ${SPACING.S24} 0;
  ${MEDIA_QUERY.MOBILE} {
    padding: ${SPACING.S24};
  }
`;

export const TitleContainer = styled.div`
  text-align: center;
  margin-bottom: ${SPACING.S16};
  ${MEDIA_QUERY.TABLET} {
    margin-bottom: ${SPACING.S24};
  }
  ${MEDIA_QUERY.DESKTOP} {
    margin-bottom: ${SPACING.S32};
  }
`;
